import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject, output } from '@angular/core';
import { LoginService } from 'src/app/login/login.service';

@Component({
    selector: 'save-data-dialog',
    templateUrl: './save-data-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SaveDataDialogComponent {
  readonly onSaveButtonClick = output<void>();

  private loginService = inject(LoginService);
  private changeDetector = inject(ChangeDetectorRef);

  public ngshowSaveDataDialog: boolean = false;
  public dialogButtonsDisabled: boolean = false;

  showSaveDataDialog() {
    this.dialogButtonsDisabled = false;
    this.ngshowSaveDataDialog = true;
    this.changeDetector.markForCheck() ;
  }

  hideSaveDataDialog() {
    this.ngshowSaveDataDialog = false;
    this.changeDetector.markForCheck() ;
  }

  logoutBtnDialogClick() {
    this.ngshowSaveDataDialog = false;
    this.loginService.studentLogout().subscribe();
  }

  saveBtnDialogClick() {
    this.dialogButtonsDisabled = true;
    this.onSaveButtonClick.emit();
  }
}
